import { onPreferencesChange, preferencesAllowed, refreshPreferences } from '@theme/yvicor-preferences-consent';

function initializeContactMaps(scope = document) {
  scope.querySelectorAll('[data-yvicor-contact-map]').forEach(container => {
    if (container.dataset.mapReady === 'true') return;
    container.dataset.mapReady = 'true';
    const placeholder = container.querySelector('[data-map-placeholder]');
    const frameHost = container.querySelector('[data-map-frame]');
    const button = container.querySelector('[data-map-preferences]');
    const error = container.querySelector('[data-map-error]');
    if (!placeholder || !frameHost || !button || !error) return;
    let mapUrl;
    try {
      mapUrl = new URL(container.dataset.mapSrc);
      if (mapUrl.protocol !== 'https:' || mapUrl.hostname !== 'www.google.com' || mapUrl.pathname !== '/maps/embed') return;
    } catch { return; }

    const sync = allowed => {
      if (!allowed || !preferencesAllowed()) {
        frameHost.querySelectorAll('iframe').forEach(frame => frame.remove());
        frameHost.hidden = true;
        placeholder.hidden = false;
        return;
      }
      if (!frameHost.querySelector('iframe')) {
        const frame = document.createElement('iframe');
        frame.width = '100%';
        frame.height = '450';
        frame.title = container.dataset.mapTitle;
        frame.loading = 'lazy';
        frame.referrerPolicy = 'no-referrer-when-downgrade';
        frame.setAttribute('allowfullscreen', '');
        // This is the only assignment of a Google iframe URL, after permission.
        frame.src = mapUrl.href;
        frameHost.append(frame);
      }
      frameHost.hidden = false;
      placeholder.hidden = true;
      error.hidden = true;
    };
    const unsubscribe = onPreferencesChange(sync);
    // Shopify's editor may replace this section; detach its old listener.
    document.addEventListener('shopify:section:unload', event => {
      if (event.target instanceof Element && event.target.contains(container)) unsubscribe();
    });
    let opening = false;
    button.addEventListener('click', async () => {
      if (opening) return;
      error.hidden = true;
      refreshPreferences();
      const banner = window.privacyBanner;
      if (typeof banner?.showPreferences !== 'function') { error.hidden = false; return; }
      opening = true;
      button.setAttribute('aria-busy', 'true');
      try {
        button.focus({ preventScroll: true });
        await banner.showPreferences();
      } catch {
        error.hidden = false;
      } finally {
        opening = false;
        button.removeAttribute('aria-busy');
      }
    });
  });
}

initializeContactMaps();
document.addEventListener('shopify:section:load', event => {
  if (event.target instanceof Element) initializeContactMaps(event.target);
});
